module.exports = __webpack_public_path__ + "static/media/uni_thumb.4802ed08.png";